import React, { useEffect, useState } from 'react';
import { TVs } from '../services/api';
import { Modal, LabeledInput, LabeledSelect } from './ui';

export default function TvEditorModal({ open, onClose, draft, groups, onSaved }) {
  const [nombre, setNombre] = useState(draft?.nombre || '');
  const [grupoId, setGrupoId] = useState(draft?.grupoId || '');
  const [tipo, setTipo] = useState(draft?.tipo || 'colas');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setNombre(draft?.nombre || '');
    setGrupoId(draft?.grupoId || '');
    setTipo(draft?.tipo || 'colas');
  }, [draft?._id, open]);

  const save = async () => {
    if (!nombre.trim()) { alert('El nombre es requerido'); return; }
    try {
      setBusy(true);
      const payload = { nombre: nombre.trim(), grupoId: grupoId || undefined, tipo };
      if (draft?._id) {
        // PATCH, fallback a PUT si el backend aún no lo soporta
        try { await TVs.patchTv(draft._id, payload); }
        catch { await fetch(`/api/pantallas/tv/${draft._id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }); }
      } else {
        await TVs.createTv(payload);
      }
      onClose(); onSaved?.();
    } catch (e) { console.error(e); alert(e.message); }
    finally { setBusy(false); }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={draft?._id ? 'Editar pantalla' : 'Nueva pantalla'}
      footer={
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="rounded-xl px-3 py-2 text-sm bg-slate-700 hover:bg-slate-600">Cancelar</button>
          <button disabled={busy} onClick={save} className="rounded-xl px-3 py-2 text-sm bg-indigo-600 hover:bg-indigo-500 disabled:opacity-60">Guardar</button>
        </div>
      }
    >
      <div className="grid gap-3">
        <LabeledInput label="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} />
        <LabeledSelect label="Tipo" value={tipo} onChange={e => setTipo(e.target.value)}>
          <option value="colas">colas</option>
          <option value="publicidad">publicidad</option>
        </LabeledSelect>
        <LabeledSelect label="Grupo" value={grupoId} onChange={e => setGrupoId(e.target.value)}>
          <option value="">(sin grupo)</option>
          {groups?.map(g => (<option key={g._id} value={g._id}>{g.nombre}</option>))}
        </LabeledSelect>
      </div>
    </Modal>
  );
}
